// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WnYI","productName":"Table_productName__2I9pS"};